import React from "react";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import "./NavBar.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="footerContainer">
        <Container maxWidth="lg">
          <div className="flex footerMain">
            <div>
              <div className="footer-title">Envision.ai</div>
              <div className="footer-text">
                <a href="https://goo.gl/maps/THs5cjfkBytE1K9fA" target="_blank" rel="noopener noreferrer">
                  800 rue du Square- <br />
                  Victoria, suite 376 <br />
                  Montreal, Quebec <br />
                  H3C 0B4 Canada
                </a>
              </div>
            </div>
            <div>
              <div className="footer-title">
                <Trans>Resources</Trans>
              </div>
              <div className="footer-text">
                <a href="mailto:info@envision.ai">
                  <Trans>Product support</Trans>
                </a>{" "}
                <br />
                <a href="https://calendly.com/envision_ai/demo" target="_blank" rel="noopener noreferrer">
                  <Trans>Request a demo</Trans>
                </a>
              </div>
            </div>
            <div>
              <div className="footer-title">
                <Trans>Company</Trans>
              </div>
              <div className="footer-text">
                <a href="https://www.envision.ai/about-us">
                  <Trans>About Us</Trans>
                </a>{" "}
                <br />
                <a
                  href="https://www.linkedin.com/jobs/envision.ai-jobs-worldwide?f_C=12179937"
                  target="_blank" rel="noopener noreferrer"
                >
                  <Trans>Careers</Trans>
                </a>
              </div>
            </div>
            <div>
              <div className="footer-title">
                <Trans>Follow Us</Trans>
              </div>
              <div className="footer-text">
                <a
                  href="https://www.linkedin.com/company/envision.ai"
                  target="_blank" rel="noopener noreferrer"
                >
                  LinkedIn
                </a>{" "}
                <br />
                <a href="https://twitter.com/envision_ai" target="_blank" rel="noopener noreferrer">
                  Twitter
                </a>{" "}
                <br />
                <a
                  href="https://www.youtube.com/channel/UC3a2svGYLlQxRh7f7poYgcQ/videos"
                  target="_blank" rel="noopener noreferrer"
                >
                  YouTube
                </a>
              </div>
            </div>
            <div style={{ minWidth: "max(20%, 150px)" }}>
              <div className="footer-title">
                <Trans>Partners &amp; Sponsors</Trans>
              </div>
              <a href="https://cmf-fmc.ca" target="_blank" rel="noopener noreferrer">
                <img
                  alt="Canada Media Fund"
                  src="https://www.envision.ai/wp-content/uploads/2021/07/cmf_logo.svg"
                />
              </a>
            </div>
          </div>
          <div className="flex footerSub">
            <div>
              <a href="https://www.envision.ai/terms-of-use/" target="_blank" rel="noopener noreferrer">
                <Trans>Terms of Use</Trans>
              </a>
            </div>
            <div>
              <a href="https://www.envision.ai/privacy-policy/" target="_blank" rel="noopener noreferrer">
                <Trans>Privacy Policy</Trans>
              </a>
            </div>
            <div>
              <a href="https://www.envision.ai/cookie-policy/" target="_blank" rel="noopener noreferrer">
                <Trans>Cookie Policy</Trans>
              </a>
            </div>
            <div>
              <a href="https://www.envision.ai/" target="_blank" rel="noopener noreferrer">
                © Envision.ai {new Date().getFullYear()}
              </a>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(Index);
